export default __webpack_public_path__ + "static/media/logo-ppa.08afd3f5.png";